export default __webpack_public_path__ + "static/char-s-55-zh-Hans-0054f4df11be390e8ab2b376ed2584d4.webp";